enum submittedType {
    firstSubmitConsideration = 1, //ส่งพิจารณาครั้งแรก
    nextPhaseProject = 2, //โครงการระยะถัดไป
    renewalProject = 3, //ขอต่ออายุโครงการ
    amendmentProject = 4, //ขอแก้ไขโครงการ
    adverseEvent = 5, //รายงานเหตุการณ์ที่ไม่พึงประสงค์
    nonconformance = 6, //รายงานที่ไม่เป็นไปตามข้อกำหนด
    closeProject = 7, //ขอปิดโครงการ
    terminateProject = 8, //ขอยุติโครงการ
    editAfterReview = 9, //แก้ไขหลังพิจารณา
    editAfterReview_nextPhaseProject = 10, //แก้ไขหลังพิจารณา (โครงการระยะถัดไป)
    exitAfterReview_AmendmentProject = 11, //แก้ไขหลังพิจารณา (ขอแก้ไขโครงการ)
    withdrawalProject = 12, //ถอนโครงการ   (การถอนทั้งโครงการ)
    withdrawalSubmitted = 13, //ถอนโครงการ   (การถอนเฉพาะการยื่นครั้งนั้น)
    editAfterReview_closeProject = 14, //แก้ไขหลังพิจารณา (ขอปิดโครงการ)
    editAfterReview_terminateProject = 15, //แก้ไขหลังพิจารณา (ขอยุติโครงการ)
    firstSubmitConsideration_notScope = 16, //ส่งพิจารณาครั้งแรก (ไม่เข้าข่าย)
    closeProjectByAdmin = 17, //ขอปิดโครงการ (โดยเจ้าหน้าที่)
    terminateProjectByAdmin = 18, //ขอยุติโครงการ (โดยเจ้าหน้าที่)
    editAfterReview_renewalProject = 19, //แก้ไขหลังพิจารณา (ต่ออายุ)

    renewalAndAmendmentProject = 20, // ขอแก้ไขพร้อมต่ออายุโครงการ
    editAfterReviewRenewalAndAmendmentProject = 21, // แก้ไขหลังพิจารณา (แก้ไขพร้อมต่ออายุโครงการ )
    highRiskProjectProgressReport = 22, // รายงานความก้าวหน้าโครงการที่มีความเสี่ยงสูง
    projectSiteVisit = 23, // เอกสารสำหรับตรวจเยี่ยมเอกสารสำหรับตรวจเยี่ยม
    editAfterReviewHighRiskProjectProgressReport = 24, // แก้ไขหลังพิจารณา รายงานความก้าวหน้าโครงการที่มีความเสี่ยงสูง
    editAfterReviewProjectSiteVisit = 25,

    projectFilesUpload = 888, // upload files
}
export default submittedType
